import { render, staticRenderFns } from "./nav.vue?vue&type=template&id=2cb2c2b8&scoped=true"
import script from "./nav.vue?vue&type=script&lang=ts"
export * from "./nav.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb2c2b8",
  null
  
)

export default component.exports